import { FC, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { Search } from "@appkit4/react-components";
import { ListType } from "routes/analysis/types/analysis";
import { searchFilter } from "services/common";
import { LoaderWrapper } from "components/common/helpers";
import { ActiveFilters } from "components/layout/filters/filters";
import { Floater } from "routes/analysis/helpers/analysisHelpers";
import ToolTip from "components/common/tooltip";
import UserMatches from "../userMatches";
import { useAtomValue } from "jotai";
import { filterAtom } from "jotai/store";
import { FetchUserTransactions } from "../queries/user";
import { UserData } from "routes/analysis/types/user";

const UserTransactions: FC<{ userData?: UserData }> = ({ userData }) => {
  const [search, setSearch] = useState("");
  const { analysisId, userId, transactionId } = useParams();

  const userFilter = useAtomValue(filterAtom);
  const { data: transactionData, isPending, error } = FetchUserTransactions(analysisId, userId, userFilter);

  return (
    <LoaderWrapper loading={[isPending]} errors={[error]}>
      <div className="flex items-center gap-4 mt-4">
        <div>
          <Search
            searchType={"secondary"}
            onChange={(value: string) => setSearch(value)}
            className="list-filter"
          />
        </div>
      </div>
      <ActiveFilters rows={transactionData?.length || 0} />
      <Floater>
        <div
          className="ap-list-header ap-business-process-header flex gap-4 p-4 pt-6 pb-6 items-center w-full">
          <div className="basis-12"></div>
          <div className="basis-96">
            Transaction
          </div>
          <div className="basis-25">
            Transaction type
          </div>
          <div className="grow"></div>
        </div>
      </Floater>
      {transactionData?.filter(f => searchFilter(f, ["description", "identifier"], search)).map((transaction, index) => (
        <div
          key={transaction.transactionId}
          id={transaction.identifier}
          className="list-row"
        >
          <Link
            className="pointer"
            to={
              transactionId === transaction.transactionId
                ? `/analysis/${analysisId}/user/${userId}`
                : `/analysis/${analysisId}/user/${userId}/transaction/${transaction.transactionId}#${transaction.identifier}`} relative="path">
            <div
              className={`flex items-center p-4 gap-4 ${transactionId === transaction.transactionId ? "ap-accordion-open" : ""}`}
            >
              <div className="basis-12">
                <span
                  className={transactionId === transaction.transactionId ? "Appkit4-icon icon-down-chevron-outline pointer" : "Appkit4-icon icon-right-chevron-outline pointer"}
                />
              </div>
              <div className="basis-96">
                <b>{transaction.identifier}</b>
                <p>{transaction.description}</p>
              </div>
              <div className="basis-25">
                {transaction.type === "T"
                  ? <ToolTip content="Transaction"><span className="Appkit4-icon icon-convert-outline"></span></ToolTip>
                  : <ToolTip content="Special transaction"><span className="Appkit4-icon icon-star-outline"></span></ToolTip>
                }
              </div>
              <div className="grow"></div>
            </div>
          </Link>
          {(userData && transactionId && transactionId === transaction.transactionId) && (
            <div className="ap-accordion-open">
              <div className="ap-wrapper-inline ap-wrapper-matches ">
                <UserMatches type={ListType.Transaction} typeId={transactionId} userData={userData} />
              </div>
            </div>
          )}
        </div>
      ))
      }
    </LoaderWrapper>
  )
}

export default UserTransactions;
